import { VersionDto } from "@/data/dto/version-dto";
import { VersionInfo } from "@/data/info/version-info";
import { assertVersionDto } from "@/utils/validation/generated/version-dto.validator";

export class VersionInfoMapper {
  static toInfo(dto: VersionDto): VersionInfo {
    assertVersionDto(dto);

    if (!dto.version.includes(" ")) {
      throw new Error("Invalid version format");
    }

    const versionResult = dto.version.replace(" ", "+");
    return {
      version: versionResult,
    };
  }
}
